import React from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

window.__BABYTRACK_V = 2;
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for offline PWA support (web only — Capacitor serves local files)
if (Capacitor.isNativePlatform()) {
  serviceWorkerRegistration.unregister();
} else {
  serviceWorkerRegistration.register();
}

reportWebVitals();
